(() => {
  const HIDDEN_CLASS = 'hidden';

  function initTabs(container) {
    const buttons = Array.from(container.querySelectorAll('[data-toggle-group]'));
    const targets = Array.from(document.querySelectorAll('[data-toggle-target]'));

    if (!buttons.length || !targets.length) return;

    buttons.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabNumber = tab.getAttribute('data-toggle-group');

        buttons.forEach(t => t.classList.toggle('active', t === tab));

        targets.forEach(step => {
          const matches = step.getAttribute('data-toggle-target') === tabNumber;
          step.classList.toggle(HIDDEN_CLASS, !matches);
        });
      });
    });

    buttons[0]?.click();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tab-container').forEach(initTabs);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.tab-container').forEach(initTabs);
  });
})();